import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import "jspdf-autotable";

const ExportTable = ({ data, columns }) => {
  const exportCSV = () => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Rides");
    XLSX.writeFile(wb, "rides.csv");
  };

  const exportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Rides");
    XLSX.writeFile(wb, "rides.xlsx");
  };

  const exportPDF = () => {
    const doc = new jsPDF();
    const tableColumn = columns.map((col) => col.header);
    const tableRows = data.map((row) =>
      columns.map((col) => row[col.accessor])
    );
    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 20,
    });
    doc.text("Rides Report", 14, 15);
    doc.save("rides.pdf");
  };

  return (
    <div className="d-flex gap-2 mb-3">
      <button onClick={exportCSV} className="btn btn-outline-secondary">
        CSV
      </button>
      <button onClick={exportExcel} className="btn btn-outline-secondary ml-2">
        Excel
      </button>
      <button onClick={exportPDF} className="btn btn-outline-secondary ml-2">
        PDF
      </button>
    </div>
  );
};

export default ExportTable;
